import React from 'react';
import PropTypes from 'prop-types';

import {
  Button,
  SelectField,
  Spacer,
  Text,
  Modal
} from 'athenaeum';

const selection = [
  {
    label: 'Life Insurance',
    value: '/life-insurance'
  },
  {
    label: 'Health Insurance',
    value: '/health-insurance'
  },
  {
    label: 'Long-term Disability Insurance',
    value: '/disability-insurance'
  },
  {
    label: 'Pet Insurance',
    value: '/pet-insurance'
  },
  {
    label: 'Renters Insurance',
    value: '/renters-insurance'
  },
  {
    label: 'Auto Insurance',
    value: '/auto-insurance'
  },
];

class SelectProductModal extends React.Component {
  constructor(props) {
    super(props);

    if (!this) {
      /* eslint-disable no-console */
      console.log("'this' was undefined.");
      /* eslint-enable no-console */
      return null;
    }

    this.state = {
      product: 'life-insurance',
      hasError: false
    };

    this.handleSelect = this.handleSelect.bind(this);
  }

  handleSelect(event) {
    if (!this) {
      /* eslint-disable no-console */
      console.log("'this' was undefined.");
      /* eslint-enable no-console */
      return null;
    }

    return this.setState({
      product: event.target.value
    });
  }

  componentDidCatch(error, info) {
    this.setState({ hasError: true });
    /* eslint-disable no-console */
    console.log('Error Boundary', error, info);
    /* eslint-enable no-console */
  }

  render() {
    if (!this) { return null; }
    if (this.state.hasError) { return <em>Whoops! Something went wrong. Please refresh</em>; }

    const {
      modalProps
    } = this.props;

    return (
      <Modal
        contentLabel="Modal"
        {...modalProps}
      >
        <div>
          <Text size={6}>What insurance are you shopping for?</Text>
          <Spacer small />
          <SelectField
            placeholder="Select a Product"
            selectOptions={selection}
            input={{
              onChange: this.handleSelect
            }}
          />
          <Spacer small />
          <Button href={this.state.product}>
            Get Quotes
          </Button>
        </div>
      </Modal>
    );
  }
}

SelectProductModal.propTypes = {
  modalProps: PropTypes.object,
};

SelectProductModal.defaultProps = {
  // Place any default props here.
};

export default SelectProductModal;



// WEBPACK FOOTER //
// ../src/templates/Footer/MainContent/SelectProductModal/index.js